import React from 'react';
import {Col, Container, Carousel, Image, Button} from 'react-bootstrap';
import {ProjectModalStyle, TextStyle} from '../assets/css/Styles';
import {GrNext, GrPrevious} from 'react-icons/gr';
/**
 *
 * @return {Component} modal for showing details of a project
 */
export default function ProjectModal({...props}) {
  const showProjectModal = props.show ?
  ProjectModalStyle.projectModalActive :
  ProjectModalStyle.projectModalDeactive;
  return (
    <div style={showProjectModal} onClick={() => props.closeModal()}>
      <Container
        style={ProjectModalStyle.modalContainer}
        onClick={(e) => e.stopPropagation()}>
        <Col style={ProjectModalStyle.modalCol}>
          <Carousel
            style={ProjectModalStyle.carouselStyle}
            controls={true}
            indicators={true}
            nextIcon={<GrNext style={ProjectModalStyle.carouselControButton} />}
            prevIcon={<GrPrevious
              style={ProjectModalStyle.carouselControButton}
            />}
            interval={2000}>
            {
              props.projectImages.map((eachImage) => (
                <Carousel.Item key={eachImage.name}>
                  <Image
                    alt={eachImage.name}
                    src={eachImage.source}
                    style={ProjectModalStyle.slideImageStyle}
                  />
                </Carousel.Item>
              ))
            }
          </Carousel>
          <Col style={ProjectModalStyle.projectDetailsCol}>
            <Col style={ProjectModalStyle.projectDetailsNameAndMottoCol}>
              <Col style={ProjectModalStyle.eachProjectDetailsNameCol}>
                <span style={TextStyle.subTitleTxt1}>{props.projectName}</span>
              </Col>
              <Col style={ProjectModalStyle.eachProjectDetailsMottoCol}>
                <span style={TextStyle.normalTxt1}>{props.projectMotto}</span>
              </Col>
            </Col>
            <Col style={ProjectModalStyle.projectDetailsDescriptionCol}>
              <span style={TextStyle.normalTxt1}>
                {props.projectDescription}
              </span>
            </Col>
            <Col style={ProjectModalStyle.projectDetailsButtonsCol}>
              {
                props.projectButtons.map((eachButton) =>
                  <Button
                    key={eachButton.name}
                    style={ProjectModalStyle.projectButtons}
                    onClick={() => window.open(eachButton.link)}>
                    <span style={TextStyle.normalTxt2}>{eachButton.name}</span>
                  </Button>,
                )
              }

            </Col>
          </Col>
        </Col>
      </Container>
    </div>
  );
}
